import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/home/")({
    component: RouteComponent,
    beforeLoad: async () => {
        throw redirect({ to: "/dashboard/home/dashboard" });
    },
});

function RouteComponent() {
    return null;
}
